const navbar = {
    doSelectedBar(t) {
        if (!t) {
            $("#hdr-navBarParents li").removeClass("bar");
            return;
        }
        const barClass = $(t).data("bar-class");
        $(t).addClass("bar " + (barClass ? barClass : "green"));
    },
    resetMenu() {
        this.doSelectedBar();
        $(".sub").hide();
    },
    setHandlers() {
        $(document).on("pointerdown", e => {
            const pointerType = e.pointerType || (e.originalEvent && e.originalEvent.pointerType);
            if ("touch" !== pointerType) {
                return;
            }
            const $target = $(e.target);
            if (
                !$target.closest("#hdr-navBarParents li").length &&
                !$target.closest(".sub").length
            ) {
                this.resetMenu();
            }
        });
        $("#hdr-navBarParents li").on("pointerenter", function (e) {
            const pointerType = e.pointerType || (e.originalEvent && e.originalEvent.pointerType);
            if ("mouse" !== pointerType) {
                return;
            }
            navbar.showSubmenu($(this));
        });
        $("#hdr-navBarParents li").on("pointerdown", function (e) {
            const pointerType = e.pointerType || (e.originalEvent && e.originalEvent.pointerType);
            if ("touch" !== pointerType) {
                return;
            }
            e.stopPropagation();
            const $li = $(this);
            const $sub = $("#" + $li.data("sub"));
            if ($sub.is(":visible")) {
                navbar.resetMenu();
                return;
            }
            navbar.showSubmenu($li);
        });
        $("#hdr-navBar .content, .sub").on("pointerleave", e => {
            const pointerType = e.pointerType || (e.originalEvent && e.originalEvent.pointerType);
            if ("mouse" !== pointerType) {
                return;
            }
            this.resetMenu();
        });
    },
    showSubmenu($li) {
        const current = $("#" + $li.data("sub"));
        const alreadyVisible = current.is(":visible");
        if (!alreadyVisible) {
            this.resetMenu();
        }
        const $container = $("#hdr-navBar").first();
        current.css({
            display: "block",
            visibility: "hidden"
        });
        const containerLeft = $container.offset().left;
        const containerWidth = $container.outerWidth();
        const liLeft = $li.offset().left - containerLeft;
        const menuWidth = current.outerWidth();
        const padding = -10;
        const offset = 10;
        let left = liLeft - offset;
        if (left + menuWidth > containerWidth - padding) {
            left = containerWidth - menuWidth - padding;
        }
        if (left < padding) {
            left = padding;
        }
        current.css({
            left: `${left}px`,
            visibility: "visible"
        });
        this.doSelectedBar($li[0]);
    },
    start() {
        this.setHandlers();
    },
};
$(() => {
    navbar.start();
});